import { useEffect, useRef, useState } from 'react';

import { redirectLogin } from 'libs/apim/redirectVolvoidApim';

const useAuthorizeVolvoId = () => {
  const [isLoading, setLoading] = useState(false);
  // Use timer to stop loading for browsers that not support popstate correctly.
  const timer = useRef<null | NodeJS.Timeout>(null);

  const authorize = async (apiId: string) => {
    setLoading(true);
    try {
      await redirectLogin(apiId, window.location.pathname);

      timer.current = setTimeout(() => {
        setLoading(false);
      }, 2000);
    } catch (e) {
      setLoading(false);
      throw e;
    }
  };

  useEffect(() => {
    // Force not loading when using browser navigation buttons.
    const forceNotLoading = () => {
      setLoading(false);
    };

    window.addEventListener('popstate', forceNotLoading);

    return () => {
      window.removeEventListener('popstate', forceNotLoading);

      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  return {
    isLoading,
    authorize,
  };
};

export default useAuthorizeVolvoId;
